// extracted by mini-css-extract-plugin
module.exports = {"imgDiv":"SocialItem_imgDiv__3vZvK","button":"SocialItem_button__1U5ct"};